let memoryDraft = {};

export const readRegistrationDraft = () => {
  return memoryDraft || {};
};

export const saveRegistrationDraft = (draft) => {
  const nextDraft = draft || {};
  memoryDraft = nextDraft;
  return nextDraft;
};

export const mergeRegistrationDraft = (partialDraft) => {
  const nextDraft = {
    ...readRegistrationDraft(),
    ...(partialDraft || {}),
  };
  return saveRegistrationDraft(nextDraft);
};

export const clearRegistrationDraft = () => {
  memoryDraft = {};
};
